<div
  class="bg-slate-100 min-h-screen w-screen flex flex-col items-center justify-center"
>
  <router-outlet></router-outlet>
</div>
